<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/136ZYlE/tc-custom/9780253008947.jpg?1718106014702" alt="This image is the cover for the book Visual Culture in the Modern Middle East"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Visual Culture in the Modern Middle East
      </h1>
      <p class="bookDescription body article font2">
        <b>A collection of essays examining the role and power of images from a wide variety of media in today’s Middle Eastern societies.</b><br/><br/>This timely book examines the power and role of the image in modern Middle Eastern societies. The essays explore the role and function of image making to highlight the ways in which the images “speak” and what visual languages mean for the construction of Islamic subjectivities, the distribution of power, and the formation of identity and belonging. <i>Visual Culture in the Modern Middle East</i> addresses aspects of the visual in the Islamic world, including the presentation of Islam on television; on the internet and other digital media; in banners, posters, murals, and graffiti; and in the satirical press, cartoons, and children’s books.<br/><br/><b>“This volume takes a new approach to the subject . . . and will be an important contribution to our knowledge in this area. . . . It is comprehensive and well-structured with fascinating material and analysis.” —Peter Chelkowski, New York University</b><br/><br/><b>“An innovative volume analyzing and instantiating the visual culture of a variety of Muslim societies [which] constitutes a substantially new object of study in the regional literature and one that creates productive links with history, anthropology, political science, art history, media studies, and urban studies, as well as area studies and Islamic studies.” —Walter Armbrust, University of Oxford</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Christiane Gruber, Sune Haugbolle
      </h2>
      
      <p class="authorDescription body article"><P>Christiane Gruber is Associate Professor of Islamic Art, Department of Art History, University of Michigan. </P><P>Sune Haugbolle is Associate Professor in Global Studies and Sociology at the Department for Society and Globalization at Roskilde University. </P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?192fc0e8